import { DataModelBuilder, isSameData, SerializationContext, SerializedData } from '../../models/dto/dto.js';
import { BusinessPrivacySettings } from '../../models/serializable/business-privacy-settings.js';
import { MapUtils } from '../../utility/map-utils.js';
import { Component } from '../core/component.js';

export class BusinessPrivacySettingsComponent extends Component {
  static readonly TYPE_ID: string = '8b0d2368e7fa4df8bfdd95d634fcaa28';

  constructor(
        public readonly settings: BusinessPrivacySettings,
  ) {
    super();
  }

  get $typeId(): string {
    return BusinessPrivacySettingsComponent.TYPE_ID;
  }

  get $removable(): boolean {
    return false;
  }

  static fromMap(context: SerializationContext, map: SerializedData): BusinessPrivacySettingsComponent {
    return new BusinessPrivacySettingsComponent(
        context.fromData<BusinessPrivacySettings>(MapUtils.getRaw(map, 'settings') as SerializedData),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'settings': context.toData(this.settings),
    };
  }

  clone(): this {
    return new BusinessPrivacySettingsComponent(
        this.settings.clone(),
    ) as this;
  }

  isSame(other: BusinessPrivacySettingsComponent): boolean {
    if(this === other) {
      return true;
    }

    return isSameData(other.settings, this.settings);
  }
}

export class BusinessPrivacySettingsComponentBuilder extends DataModelBuilder<BusinessPrivacySettingsComponent> {
  build(context: SerializationContext, map: SerializedData): BusinessPrivacySettingsComponent {
    return BusinessPrivacySettingsComponent.fromMap(context, map);
  }
}
